/**
 * @generated SignedSource<<3251c0fdd7c691da03a533537bcab099>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProfileIconButtonLogoutMutation$variables = Record<PropertyKey, never>;
export type ProfileIconButtonLogoutMutation$data = {
  readonly logout: boolean;
};
export type ProfileIconButtonLogoutMutation = {
  response: ProfileIconButtonLogoutMutation$data;
  variables: ProfileIconButtonLogoutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "logout",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileIconButtonLogoutMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileIconButtonLogoutMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f2087c0179de2d4cec306a41a2acba91",
    "id": null,
    "metadata": {},
    "name": "ProfileIconButtonLogoutMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileIconButtonLogoutMutation {\n  logout\n}\n"
  }
};
})();

(node as any).hash = "bb00f9a35b31a8efc305d241167f1965";

export default node;
